import { useAuth } from '@polvo-labs/react-auth'
import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import Form from '../../../../components/Form'
import Select from '../../../../components/Form/Fields/Select'
import FieldType from '../../../../components/Form/Fields/type'
import { REALTY_OPTION_TYPE } from '../../../../config/realty-types'
import { Status, STATUS } from '../../../../models/Realty'

export interface FilterData {
  texto: string
  status: string
  type: string
  city: string
  owes_since: string
}

interface Props {
  filters?: string[]
  initialParams?: FilterData
  onChange: (data: FilterData) => void
}
const fields: FieldType<keyof FilterData>[] = [
  {
    name: 'texto',
    data: {
      label: '',
    },
    html: {
      maxLength: 255,
      placeholder: 'Pesquisar',
    },
  },
  {
    name: 'status',
    component: Select,
    data: {
      label: '',
      options: [
        {
          label: 'Status',
          value: '',
        },
        ...Object.keys(STATUS).map((key: string) => ({
          label: STATUS[key as Status],
          value: key,
        })),
      ],
    },
  },
  {
    name: 'type',
    component: Select,
    data: {
      label: '',
      options: [
        {
          label: 'Tipo do imóvel',
          value: '',
        }
      ],
    },
  },
  {
    name: 'city',
    data: {},
    html: { placeholder: 'Cidade' },
  },
  {
    name: 'owes_since',
    component: Select,
    data: {
      label: '',
      options: [
        {
          label: 'Anos devendo',
          value: '',
        },
        {
          label: '0-2',
          value: '0-2',
        },
        {
          label: '2-5',
          value: '2-5',
        },
        {
          label: '5-10',
          value: '5-10',
        },
        {
          label: '10+',
          value: '10+',
        },
      ],
    },
  },
]

const Filter: React.FC<Props> = ({
  onChange,
  filters,
  initialParams = {
    texto: '',
    owes_since: '',
    city: '',
    type: '',
    status: '',
  } }) => {

  const [fieldsIn, setFieldsIn] = useState<FieldType<keyof FilterData>[]>(fields)

  const { token } = useAuth()

  useEffect(() => {
    let mounted = true
    Axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/realty_types`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((data) => {
      if (mounted) {
        let types: REALTY_OPTION_TYPE[] = []

        data.data.data.forEach((item: any) => {
          types.push({ label: item.type, value: item.type })
        })
        const formattedFields: FieldType<keyof FilterData>[] = fields.map((field: FieldType<keyof FilterData>) => {
          if (field.name === 'type') {
            return {
              name: 'type',
              component: Select,
              data: {
                label: '',
                options: [
                  {
                    label: 'Tipo do imóvel',
                    value: '',
                  },
                  ...types
                ],
              },
            }
          } else
            return field
        })
        setFieldsIn(formattedFields)
      }
    })
    return () => {
      mounted = false
    }
  }, [])


  return (
    <Form<FilterData>
      buttonLabel="Filtrar"
      fields={fieldsIn}
      initialValues={initialParams}
      onSubmit={data => {
        const keys = Object.keys(data) as (keyof FilterData)[]
        keys.map(k => (data[k] === '') && delete data[k])
        onChange(data)
      }}
      horizontal
      buttonProps={{
        backgroundColor: 'transparent',
        fontColor: 'darkBlue',
        borderColor: 'darkBlue',
      }}
    />
  )
}

export default Filter
